import posthog from 'posthog-js';
import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment';
import { analyticsOptOut } from '../utils/privacy';

export const trackChangeFilter = (filterType, context = 'requests_page') => {
  if (analyticsOptOut.hasOptedOut()) return;
  
  const eventData = {
    filter_type: filterType,
    context: context,
    ...getEnvironmentData()
  };

  posthog.capture('change_filter', eventData);
  track('change_filter', eventData);
  
  // Add TikTok tracking
  if (typeof window !== 'undefined' && window.ttq) {
    window.ttq.track('ViewContent', {
      content_name: 'filter_change',
      content_type: 'product',
      content_id: `filter_${filterType}`
    });
  }
}; 